// extracted by mini-css-extract-plugin
module.exports = {"cookieBanner":"CookiesNotification_cookieBanner__WV7AL","pop-fade-in":"CookiesNotification_pop-fade-in__vyFce"};